import { useEffect, useState } from "react";
import "react-quill/dist/quill.snow.css"; // Import Quill styles
import { useNavigate } from "react-router-dom";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import { useFlag } from "../../hooks";
import { FLAGS } from "../../utils/Constant/FlagConstant";
import { checkFields } from "../../utils/Validation/checkFields";
import { createCurrency, updateCurrency } from "../../utils/ApiCalls/Currecny";

const CurrencyInput = ({ currency }) => {
  const [name, setName] = useState("");
  const [isDefault, setIsDefault] = useState(false);
  const [exchangeRateToUsd, setExchangeRate] = useState([]);
  const [sc_currency, setScCurrency] = useState("");
  const [tc_currency, setTcCurrency] = useState("");
  const [bahasa_currency, setBahasaCurrency] = useState("");
  const { enabled: isLoyaltee } = useFlag(FLAGS.WEB_LOYALTEE);
  const [, dispatch] = useDataLayerValue();
  const [error, setError] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    if (currency) {
      setName(currency?.currency);
      setExchangeRate(currency.exchangeRateToUsd);
      setScCurrency(currency.sc_currency || "");
      setTcCurrency(currency.tc_currency || "");
      setBahasaCurrency(currency.bahasa_currency || "");
    }
  }, [currency]);
 

  const addcurrency = async (e) => {
    e.preventDefault();
    let added = false;
    let dataValues = {
      currency: name,
      exchangeRateToUsd,
      sc_currency,
      tc_currency,
      bahasa_currency,
    };

    let valid = checkFields(dataValues);
    if (valid) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: valid, type: "error" },
      });
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });
      setError(valid);
    } else {
      setError();

      const values = {
        ...dataValues,
      };

      let data;
      if (currency?.id) {
        data = await updateCurrency(currency.id, values);
      } else {
        data = await createCurrency(values);
      }
      if (data?.error) {
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: data.error, type: "error" },
        });
        added = false;
      } else {
        added = true;
      }

      if (added && !currency.id) {
        navigate("/website/loyalty/currency");
      } else {
        navigate("/website/loyalty/currency");
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: "Values updated", type: "success" },
        });
      }
    }
  };
  return (
    <div>
      <section className="content">
        {error && (
          <div className="d-flex justify-content-center align-items-center text-danger">
            <p>{error}</p>
          </div>
        )}

        <div className="container-fluid">
          <div className="card">
            <form className="input_form" onSubmit={addcurrency}>
              <div className="card-body">
                <div className="row">
                  <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label htmlFor="currency" className="f_label">Currency</label>
                      <input
                        id="currency"
                        required
                        className="f_input"
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                  </div>

                  {isLoyaltee && (
                    <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                      <div className="fieldrow">
                        <label htmlFor="sc_currency" className="f_label">Simplified Chinese Currency</label>
                        <input
                          id="sc_currency"
                          className="f_input"
                          type="text"
                          value={sc_currency}
                          onChange={(e) => setScCurrency(e.target.value)}
                        />
                      </div>
                    </div>
                  )}
                  {isLoyaltee && (
                    <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                      <div className="fieldrow">
                        <label htmlFor="tc_currency" className="f_label">Traditional Chinese Currency</label>
                        <input
                          id="tc_currency"
                          className="f_input"
                          type="text"
                          value={tc_currency}
                          onChange={(e) => setTcCurrency(e.target.value)}
                        />
                      </div>
                    </div>
                  )}
                  {isLoyaltee && (
                    <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                      <div className="fieldrow">
                        <label htmlFor="bahasa_currency" className="f_label">Bahasa Currency</label>
                        <input
                          id="bahasa_currency"
                          className="f_input"
                          type="text"
                          value={bahasa_currency}
                          onChange={(e) => setBahasaCurrency(e.target.value)}
                        />
                      </div>
                    </div>
                  )}

                  <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label htmlFor="exchangeRateToUsd" className="f_label">Exchange rate for usd</label>
                      <input
                        id="exchangeRateToUsd"
                        required
                        className="f_input"
                        type="text"
                        value={exchangeRateToUsd}
                        onChange={(e) => setExchangeRate(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

              </div>

              <div className="card-footer text-right">
                <button className="btn main_submit">
                  {currency?.id ? "Update" : "Add"} currency
                </button>
              </div>
            </form>
          </div>
          <div className="pt-3"></div>
        </div>
      </section>
    </div>
  );
};

export default CurrencyInput;
